import React from 'react';
import { ButtonBase, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '8.438rem',
    height: '2.25rem',
    borderRadius: '0.625rem',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
  },
}));

export default function ClockBtn(props) {
  const { children, status } = props;

  const styles = [{ background: '#28d2ab' }, { background: '#7b80ff' }];
  const classes = useStyles();
  return (
    <ButtonBase {...props} className={classes.root} style={styles[status]}>
      {children}
    </ButtonBase>
  );
}
